(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire70d3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire70d3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("9JoR4", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $715b98b266af0a32$export$6503ec6e8aabbaf; }, function (v) { return $715b98b266af0a32$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $715b98b266af0a32$export$f7ad0328861e2f03; }, function (v) { return $715b98b266af0a32$export$f7ad0328861e2f03 = v; });
var $715b98b266af0a32$export$6503ec6e8aabbaf;
var $715b98b266af0a32$export$f7ad0328861e2f03;
"use strict";
var $715b98b266af0a32$var$mapping = new Map();
function $715b98b266af0a32$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$715b98b266af0a32$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $715b98b266af0a32$var$resolve(id) {
    var resolved = $715b98b266af0a32$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$715b98b266af0a32$export$6503ec6e8aabbaf = $715b98b266af0a32$var$register;
$715b98b266af0a32$export$f7ad0328861e2f03 = $715b98b266af0a32$var$resolve;

});

parcelRegister("5mK0a", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $3e82b0d0e999653d$export$bdfd709ae4826697; }, function (v) { return $3e82b0d0e999653d$export$bdfd709ae4826697 = v; });
var $3e82b0d0e999653d$export$bdfd709ae4826697;
var $3e82b0d0e999653d$export$c9e73fbda7da57b6;
var $3e82b0d0e999653d$export$5a759dc7a1cfb72a;
"use strict";
var $3e82b0d0e999653d$var$bundleURL = {};
function $3e82b0d0e999653d$var$getBundleURLCached(id) {
    var value = $3e82b0d0e999653d$var$bundleURL[id];
    if (!value) {
        value = $3e82b0d0e999653d$var$getBundleURL();
        $3e82b0d0e999653d$var$bundleURL[id] = value;
    }
    return value;
}
function $3e82b0d0e999653d$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $3e82b0d0e999653d$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $3e82b0d0e999653d$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $3e82b0d0e999653d$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$3e82b0d0e999653d$export$bdfd709ae4826697 = $3e82b0d0e999653d$var$getBundleURLCached;
$3e82b0d0e999653d$export$c9e73fbda7da57b6 = $3e82b0d0e999653d$var$getBaseURL;
$3e82b0d0e999653d$export$5a759dc7a1cfb72a = $3e82b0d0e999653d$var$getOrigin;

});

var $21e3aeacb3549fc9$exports = {};


(parcelRequire("9JoR4")).register((parcelRequire("5mK0a")).getBundleURL("akKmz"), JSON.parse('["akKmz","index.06b12965.js","hcu2T","Grocery.b62deadb.js"]'));

})();
//# sourceMappingURL=index.runtime.6b2a4fdb.js.map
